import React from 'react';

const ConfirmTicket = () => {
    return (
        <div>
            <h1 style={{fontSize:"48px", margin:"120px" }} className="bg-succes text-warning">Thank you, Your Ticket is Booked</h1>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    );
};

export default ConfirmTicket;